declare namespace $ {

	type $mol_list__rows_bog_ainews_app_sources_1 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['My_rss_feeds'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_bog_ainews_app_sources_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_ainews_app_sources_3 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['add_custom_feed_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__rows_bog_ainews_app_sources_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_labeler__title_bog_ainews_app_sources_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_sources_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_list__rows_bog_ainews_app_sources_7 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['Categories'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_labeler__title_bog_ainews_app_sources_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_sources_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_select_list__value_bog_ainews_app_sources_10 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['sources'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__dictionary_bog_ainews_app_sources_11 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['suggestions'] >
		,
		ReturnType< $mol_select_list['dictionary'] >
	>
	type $mol_list__rows_bog_ainews_app_sources_12 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['articles'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_ainews_app_sources_13 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['my_rss_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__sub_bog_ainews_app_sources_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_bog_ainews_app_sources_15 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['delete_custom_feed_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_labeler__title_bog_ainews_app_sources_16 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_sources['category_title'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_ainews_app_sources_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_bog_ainews_app_sources_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ainews_app_sources extends $bog_ainews_app_page {
		My_rss_feeds( ): readonly(any)[]
		My( ): $mol_list
		Add_feed_string( ): $mol_string
		add_custom_feed_click( next?: any ): any
		Add_feed_button( ): $mol_button_minor
		My_sources_labeler_content( ): $mol_list
		My_sources_labeler( ): $mol_labeler
		Categories( ): readonly(any)[]
		Tabs( ): $mol_list
		Sources_labeler( ): $mol_labeler
		category_title( id: any): string
		sources( id: any, next?: readonly(any)[] ): readonly(any)[]
		suggestions( id: any): readonly(any)[]
		Sources( id: any): $mol_select_list
		articles( id: any): readonly(any)[]
		Items( id: any): $mol_list
		my_rss_title( id: any): string
		RSS_title( id: any): $mol_paragraph
		Delete_close_icon( id: any): $mol_icon_close
		delete_custom_feed_click( id: any, next?: any ): any
		Delete_my_feed_button( id: any): $mol_button_major
		runtime_links( ): any
		custom_sources( id: any, next?: readonly(any)[] ): readonly(any)[]
		title( ): string
		Logo( ): $mol_icon_open_source_initiative
		body( ): readonly(any)[]
		Category_page( id: any): $mol_labeler
		My_rss_item( id: any): $mol_view
	}
	
}

//# sourceMappingURL=sources.view.tree.d.ts.map